function playVideo(container) {
	const targetOverlay = $('.ab-video-overlay');
	const targetVideo = $('#video-overlay-player');
	const videoSrc = $(container).find('.js-video-open').data('video');

	$(targetVideo).attr('src', videoSrc);
	$(targetOverlay).addClass('visible');
	$(targetVideo).get(0).play();
}
function initVideo(target) {

	$(target).find('.js-video-open').off("click"); //per evitare di assegnare più eventi click allo stesso bottone
	$(target).find('.js-video-open').on('click', function (event) {
		playVideo(target);
		event.preventDefault()
	});
}
const $_videos = $('.ab-video');

if ($_videos.length > 0) {
	$_videos.each(function () {
		initVideo(this);
	});
}

$('.js-video-close').on('click',function(){
	let targetOverlay = $(this).closest('.ab-video-overlay');
	let targetVideo = $(targetOverlay).find('video');
	$(targetVideo).get(0).pause();
	$(targetVideo).get(0).currentTime = 0;
	$(targetOverlay).removeClass('visible');
})